'use client';
import React, { ReactNode } from 'react';
import { Anchor, AppShell, AppShellMain, Box, Divider, Flex, Group } from '@mantine/core';
import crane from '../../../public/images/crane-bg.jpg';
import Image from 'next/image';

const Layout = ({ children }: { children: ReactNode }) => {
  return (
    <AppShell
      h="100vh"
      navbar={{
        width: 400,
        breakpoint: 'sm',
      }}
    >
      <AppShellMain h="100vh" style={{ overflow: 'hidden' }}>
        <Box
          h="100vh"
          w="100%"
          style={{
            background: 'linear-gradient(90deg, #fdc331 0%, #fa9742 39.76%, #da43e7 100%)',
            opacity: 0.5,
            overflow: 'hidden',
          }}
        >
          <Image
            priority
            src={crane}
            alt="crane"
            placeholder="blur"
            style={{
              objectFit: 'cover',
              opacity: 0.8,
              objectPosition: 'top 20%',
            }}
            fill
          />
        </Box>
      </AppShellMain>
      <AppShell.Navbar p="md">
        <Flex justify="center" align="center" direction="column" h="100%">
          <Flex justify="center" align="center" direction="row" mt="sm">
            {children}
          </Flex>
          <Group mt="auto" justify="center">
            <Anchor
              c="orange.5"
              href="https://shepherd-public.s3.us-west-1.amazonaws.com/Shepherd+Labs+-+Terms+of+Use.pdf"
              target="_blank"
              style={{ textDecoration: 'underline' }}
            >
              Terms of Service
            </Anchor>{' '}
            <Divider orientation="vertical" />
            <Anchor
              c="orange.5"
              href="https://shepherd-public.s3.us-west-1.amazonaws.com/Shepherd+Labs+-+Privacy+Policy.pdf"
              target="_blank"
              style={{ textDecoration: 'underline' }}
            >
              Privacy Policy
            </Anchor>
          </Group>
        </Flex>
      </AppShell.Navbar>
    </AppShell>
  );
};

export default Layout;
